import { useUser } from "../../contexts/UserContext/hooks/useUser";
import { FEATURES, PERMISSIONS } from "./permissions";

export default function usePermissions() {
  const { userRole, currentOrganization } = useUser();
  const organizationType = currentOrganization?.organizationType;

  const can = (feature: FEATURES): boolean => {
    if (!organizationType || !userRole) {
      return false;
    }

    return PERMISSIONS[organizationType][userRole][feature];
  };

  return { can };
}
